import styled from 'styled-components';

import arrowRightIconUrl from '~/assets/images/icons/simple-arrow-right.svg';
import {SkeletonLoader} from '~/shared/components/Loaders';
import {media, flipOnLTR} from '~/shared/theme/utils';
import ImageWithAlt from '~/shared/components/ImageWithAlt';
import {flexColumn, flexColumnCenterVertically} from '~/shared/theme/FlexLayout';
import {Link as _Link} from '~/shared/router';
import {body13Normal} from '~/shared/theme/typography';
import {DETAILS_TYPES} from '~/shared/consts/userReportConsts';

export const ModifiedSkeletonLoading = styled(SkeletonLoader)`
  margin-top: ${({noMarginTop}) => (noMarginTop ? 0 : 86)}px;
  height: ${({height}) => height || 95}px;
`;

export const Root = styled.div`
  ${flexColumn}
  ${({spaceTop}) => spaceTop && 'margin-top: 38px;'}
  width: 100%;
  ${({theme, borderBottom}) => (borderBottom && `border-bottom: 8px solid ${theme.colors.actionSecondary};`)}
`;

export const TableMobileWrapper = styled.div`
  background: ${({theme}) => theme.userReport.transactionTable.background.row};
`;

export const Arrow = styled(ImageWithAlt).attrs(() => ({
  src: arrowRightIconUrl,
}))`
  position: absolute;
  left: auto;
  right: 9px;
  width: 6px;
  height: 14px;
  top: calc(50% - 7px);
  z-index: 1;
  display: ${({forward: isForwardArrow, allowedToStepForward}) =>
    (isForwardArrow ? (allowedToStepForward ? 'block' : 'none') : 'block')};
  cursor: ${({forward: isForwardArrow, allowedToStepForward}) =>
    (isForwardArrow ? (allowedToStepForward ? 'pointer' : 'inherit') : 'pointer')};
  ${({forward: isForwardArrow}) =>
    !isForwardArrow &&
    `
    transform: rotate(180deg);
    right: auto;
    left: 9px;
  `}
`;

export const Row = styled.div`
  display: flex;
  justify-content: ${({spaceBetween}) => (spaceBetween ? 'space-between' : 'inherit')};
  padding: 12px 15px;
  color: ${({theme}) => theme.userReport.showOrder.text};
  ${media.minLargeMobile`
    border-radius: 8px;
  `}

  ${({narrow}) =>
    narrow &&
    flipOnLTR`
    padding-left: 37px;
  `}
  ${({total, theme, customTableFooterColor}) =>
    total &&
    `
    background: ${customTableFooterColor || theme.userReport.totalsTable.markedRowBackground};
    font-weight: bold;
    color: ${theme.userReport.totalsTable.text};
  `}
  ${({mobile}) => mobile && 'padding: 5px 15px;'}
  ${media.minDesktop`
    ${({total}) =>
    total &&
      `
      margin: 0;
      padding: 12px 15px;
    `}
  `}
`;

export const DateAndTime = styled.div`
`;

export const Column = styled(Row)`
  ${flexColumn};
  justify-content: inherit;
`;

export const InnerRow = styled.div`
  display: flex;
  justify-content: ${({flexStart}) => (flexStart ? 'flex-start' : 'space-between')};
  font-weight: ${({bold: isBold}) => (isBold ? 'bold' : 'normal')};
  color: ${({theme}) => theme.userReport.general.text};
`;

export const PriceWrapper = styled.div`
  display: flex;
  white-space: no-warp;
  font-weight: ${({isBold}) => (isBold ? 'bold' : 'normal')};
  width: ${({width}) => width || 60}px;
  justify-content: ${({theme}) => (theme.isLTR ? 'inherit' : 'flex-end')};
  direction: rtl;
  ${media.minDesktop`
    direction: ${({theme}) => (theme.isLTR ? 'ltr' : 'rtl')};
    justify-content: ${({theme}) => (theme.isLTR ? 'inherit' : 'flex-start')};
  `}
`;

export const CancelLabel = styled.div`
  font-weight: ${({isBold}) => (isBold ? 'bold' : 'normal')};
  color: ${({theme}) => theme.userReport.sendDebitTransferRequestModal.errorColor};
  ${({theme}) => !theme.isLTR && 'margin-right: 5px;'}
`;

export const DetailsBox = styled.div`
  width: 100%;
  border-radius: 12px;
  ${flexColumnCenterVertically};
  text-align: center;
  ${({isMobile, theme}) => !isMobile && `
    box-shadow: ${theme.shadows.elevationCard};
    padding: 16px 0;
  `}
  background-color: ${({theme}) => theme.userReport.moneyCardDetails.background};
`;

export const Text = styled.div`
  color: ${({theme}) => theme.userReport.moneyCardDetails.text};
  margin-bottom: ${({spaceDown}) => (spaceDown ? 24 : 0)}px;
  ${({isMobile}) =>
    isMobile &&
    `
    ${body13Normal};
  `}
`;

export const Sum = styled.div`
  font-weight: bold;
  font-size: ${({isMobile}) => (isMobile ? 18 : 28)}px;
  color: ${({type, theme}) =>
    (type === DETAILS_TYPES.BALANCE
      ? theme.userReport.moneyCardDetails.balanceNumberText
      : theme.userReport.moneyCardDetails.numberText)};
`;
